<template>
  <confirmation-dialog
    v-if="enabled"
    :title="title"
    :enabled="enabled"
    :dialogColor="dialogColor"
    :abortButtonMessage="abortButtonMessage"
    :confirmationButtonColor="'primary'"
    :confirmationButtonMessage="confirmationButtonMessage"
    :confirmationMessage="message"
    @abort="$emit('abort')"
    @confirm="$emit('confirm')"
  >
    <v-layout>
      <v-flex xs12>
        <v-list height="100" style="overflow-y: auto">
          <template v-for="index in listFiles.length*2">
            <v-divider v-if="index%2==0" :key="index" />
            <v-list-item v-else :key="index">
              <v-list-item-title>{{listFiles[(index-1)/2].name}}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </confirmation-dialog>
</template>

<script>
import ConfirmationDialog from "@/components/templates/ConfirmationDialog";
export default {
    components: { ConfirmationDialog },
    props: {
        enabled: { required: true, type: Boolean },
        title: { required: true, type: String },
        confirmationButtonMessage: { default: '', type: String },
        message: { required: true, type: String },
        abortButtonMessage: { default: 'Cancelar', type: String },
        dialogColor: { default: 'primary', type: String },
        listFiles: { required: true, type: Array },
    }
}
</script>